import { ActionRepositoryImpl } from "../data/ActionRepositoryImpl";
import { IActionRepository } from "../domain/repositories/IActionRepository";
import { ActionUseCase } from "../domain/useCases/ActionUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ActionInjection extends InjectionModule {
  private static readonly actionRepositoryToken = Symbol("IActionRepository");
  private static readonly actionUseCaseToken = Symbol("ActionUseCase");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.actionRepositoryToken,
      useClass: ActionRepositoryImpl,
    },
    {
      scope: "otherRepo",
      token: this.actionUseCaseToken,
      useClass: ActionUseCase,
    },
  ];

  static getRepo(): IActionRepository {
    return this.resolve(this.actionRepositoryToken);
  }

  static getUseCase(): ActionUseCase {
    return this.resolve(this.actionUseCaseToken);
  }
}
